module.exports = __webpack_public_path__ + "static/hr_ad_2-0d99f08e4b4bd45dda053d73584a6fb0.png";